import { render } from "./AccountBankUpdatePhoto.vue?vue&type=template&id=398939ba&scoped=true"
import script from "./AccountBankUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./AccountBankUpdatePhoto.vue?vue&type=script&lang=js"

import "./AccountBankUpdatePhoto.vue?vue&type=style&index=0&id=398939ba&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398939ba"]])

export default __exports__